"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
require("./index.scss");
const CategoryTag = ({ className, category, style }) => {
    if (!category || (!category.name && !category.title)) {
        console.log('Problem with category object:', category);
        return null;
    }
    const cN = ['ds-category-tag'];
    if (className)
        cN.push(className);
    let s = category.name || category.title;
    if (category.tag &&
        category.tag.trim() !== '' &&
        category.tag !== (0, i18n_1.t)('UNAV_CAT_NO_TAG')) {
        s = `${category.tag.trim()} - ${s || ''}`.trim();
    }
    return (react_1.default.createElement("div", { className: cN.join(' '), style: style }, s));
};
exports.default = CategoryTag;
